import styles from './TermsModal.module.scss';

import { Button } from '@/components/Button';
import { Modal } from '@/components/Modal';
import { storage } from '@/utils/storage';

import { useTranslation } from 'react-i18next';

interface TermsModalProps {
  isVisible: boolean;
  onClose: () => void;
}

export const TermsModal: React.FC<TermsModalProps> = ({
  isVisible,
  onClose,
}) => {
  const { t } = useTranslation();

  const handleContinue = async () => {
    await storage.setItem('termsAccepted', 'true');
    onClose();
  };

  const handleLinkClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open(
      'https://telegra.ph/Pollo-Terms-of-Service-and-User-Agreement-09-13',
      '_blank',
    );
  };

  return (
    <Modal isVisible={isVisible} onClose={onClose} minHeight="auto">
      <div className={styles.container}>
        <div className={styles.content}>
          <h2 className={styles.title}>
            {t('termsModal.title', 'Terms of Service')}
          </h2>
          <p className={styles.text}>
            {t(
              'termsModal.description',
              'By continuing you acknowledge terms of services and user agreement',
            )}
          </p>
          <a
            href="https://telegra.ph/Pollo-Terms-of-Service-and-User-Agreement-09-13"
            onClick={handleLinkClick}
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('termsModal.linkText', 'Terms of Service and User Agreement')}
          </a>
        </div>
        <div className={styles.actions}>
          <Button onClick={handleContinue} gradient>
            {t('termsModal.continue', 'Continue')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
